<div *ngIf="vm$ | async as vm" class="flex flex-col justify-between h-full">
	<div class="space-y-4 flex-1 overflow-auto">
		<h4>AI Scanned Contact From Document</h4>
		<p>This contact was created based on the document you uploaded.</p>

		<div class="flex items-center gap-4">
			<input
				type="radio"
				name="client"
				[id]="vm.client.id"
				[(ngModel)]="vm.selectedClient"
				[value]="vm.client"
			/>
			<label class="flex-1" [for]="vm.client.id">
				<app-container>
					<atomic-party-client-card [client]="vm.client" [hideIdv]="true" />
				</app-container>
			</label>
		</div>
		<hr />
		<h4>Similar Contacts</h4>
		<p>Select from an existing contact below to update the buyer on matter.</p>
		<div
			class="flex items-center gap-4 text-gray-500 px-2 py-4"
			*ngIf="isLeapMatter && vm.fetchingSimilarContacts === true"
		>
			<i-tabler [class.animate-spin]="true" name="loader"></i-tabler>
			<span>Loading LEAP contacts</span>
		</div>
		<ng-container *ngIf="vm.fetchingSimilarContacts === false">
			<div
				class="flex items-center gap-4"
				*ngFor="let similarClient of vm.similarClients"
			>
				<input
					type="radio"
					name="client"
					[id]="similarClient.id"
					[(ngModel)]="vm.selectedClient"
					[value]="similarClient"
				/>
				<label class="flex-1" [for]="similarClient.id">
					<app-container>
						<atomic-party-client-card
							[client]="similarClient"
							[hideIdv]="true"
						/>
					</app-container>
				</label>
			</div>
		</ng-container>
	</div>
	<ui-content-footer
		[primaryAction]="{
			text: 'Confirm',
			action: confirm,
		}"
		[secondaryAction]="{ text: 'Cancel', action: cancel }"
	/>
</div>
